import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px 0 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #333;
  position: relative;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;

export const Logo = styled.img`
  height: 40px;
`;

export const Section = styled.section`
  margin: 80px 0;
  padding: 0 20px;
  position: relative;
  text-align: center;
  
  & > h2, & > h3 {
    text-align: center;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  
  & > h2 {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 40px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background: linear-gradient(90deg, rgba(0,102,255,0.2) 0%, rgba(0,102,255,0.8) 50%, rgba(0,102,255,0.2) 100%);
      border-radius: 3px;
    }
  }
`;

export const Divider = styled.hr`
  border: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(0,0,0,0.01) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.01) 100%);
  margin: 60px 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: #0066ff;
    border-radius: 50%;
    opacity: 0.5;
  }
`;

export const Footer = styled.footer`
  text-align: center;
  padding: 40px 0;
  color: #777;
  font-size: 0.875rem;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 1px;
    background: linear-gradient(90deg, rgba(0,102,255,0.1) 0%, rgba(0,102,255,0.3) 50%, rgba(0,102,255,0.1) 100%);
  }
`; 